import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Profile from "../../../Assets/AppComponent/Profile/profile2.png";
import { useNavigate } from "react-router-dom";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import {
  gettheSkillassessmentRetireveEmpactions,

  settheStandardIDS,
  setTheNameFormForm,
  setManpowerActivetabs,
  setthelistifskillassessment,
  setthetotal_ids,
  setTheListNamesactions,
  settheformforskillassessment,
  setThePutIdAnswerIds,
  setTheLastPerformanceIds,
  settheEmpAssessmentNames
} from "../../../Redux/Slice"
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pending from "../../../Assets/AppComponent/icons/Group 145.svg";
import ArrowIcons from "../../../Assets/AppComponent/Arrow/Vector .svg";

const Empskillassessments = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const navigate = useNavigate();
  useEffect(() => {
    const payload = {
      EditId: state.ManPowerActiveDataTabs.Employeeskillassessmentids
    }
    dispatch(gettheSkillassessmentRetireveEmpactions(payload))
  }, [state.ManPowerActiveDataTabs.Employeeskillassessmentids])
  useEffect(() => {
    // Check if data is available
    if (
      state.skillassessmentretieveempdatas &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types &&
      Array.isArray(state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types.perform_id)
    ) {
      const performIdList = state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types.perform_id;
  
      const listofObjects = performIdList.map((item) => ({
        grading_name: item.grading_name,
        total_points: item.total_points,
        id: item.id,
        points:item.points

      }));
  
      console.log(listofObjects, "Processed listofObjects");
  
      // Dispatch action to store listofObjects in Redux
      dispatch(setthelistifskillassessment(listofObjects));

      if (state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined) {
        var total_id = [];
        var namelist = [];
        state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
        state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types !=
            undefined &&
            state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types !=
            null &&
            state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types
            .perform_id != undefined &&
            state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types
            .perform_id != null &&
          state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types.perform_id.map(
            (item) => {
              total_id.push(item.id);
              //  console.log(item.id  ,"sdcasyicgfa");
              namelist.push(item.grading_name);
            }
          );
        //  console.log(total_id ,"total_id");
  
        dispatch(setthetotal_ids(total_id));
        dispatch(setTheListNamesactions(namelist));
      }


    } else {
      console.warn("Data not fully loaded or perform_id is missing.");
    }
    if (
      state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas != null &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
        undefined &&
        state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
        null
    ) {

      dispatch(
        setThePutIdAnswerIds(
          state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer
            .id
        )
      );
      //perform_answer

    }
       ////---performance-----Last---Name---
       if (
        state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
        state.skillassessmentretieveempdatas.skillassessmentsempDatas != null &&
        state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types !=
          null &&
          state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types !=
          undefined &&
          state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types
          .perform_id != undefined &&
          state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types
          .perform_id != null
      ) {
         console.log(state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types.perform_id ,"asldlaskjd lkasjd ");
         
        state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types.perform_id.map(
          (item, index) => {

            if (
              index ==
              state.skillassessmentretieveempdatas.skillassessmentsempDatas
                .perform_types.perform_id.length -
                1
            ) {
              /////---the----last---name----dispatch-
              dispatch(setTheLastPerformanceIds(item.grading_name));
            }
         
          }
        );
      }
  }, [state.skillassessmentretieveempdatas.skillassessmentsempDatas , 
    state.ManPowerActiveDataTabs.EditIDs,
    state.ManPowerActiveDataTabs.Employeeskillassessmentids
  ]);
  
  console.log(state.ManPowerActiveDataTabs.LastIDSPerformanceidss ,"state.ManPowerActiveDataTabs.LastIDSPerformanceidss");
  
  

  //   console.log(state.ManPowerActiveDataTabs.NamesForFormsArray,"sadhasoid oaisd d"
  //     ,
  //     state.ManPowerActiveDataTabs.ListofSkillAssessment
  // );

  const HandleManPowerfunction = (item, index) => {
    // console.log(item.grading_name ,"sdiousaoiduasd ");
    
    setTimeout(() => {
      dispatch(setTheNameFormForm(item.grading_name))
dispatch(settheEmpAssessmentNames(item.grading_name))
    dispatch(settheStandardIDS(item.id));
    // dispatch(setTheNameFormForm({
    //   grading_name:item.grading_name,
    //   total_points:item.total_points,
    //   id:item.id
    // }));
      
    const listofObjects = [{
      grading_name: item.grading_name,
      total_points: item.total_points,
      id: item.id,
      points:item.points
    }]

     dispatch(settheformforskillassessment(listofObjects))
    dispatch(setManpowerActivetabs(index));
    navigate("/assessments_form");
    }, 1000);

    // if (item.id == state.ManPowerActiveDataTabs.Ids) {
    // }
  };

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div className="leaveWrapper">

          <div className="row ButtonPrevious Filters"
            style={{
              margin: "0px",
              position: "relative",
              zIndex: "30",
              marginLeft: "0px",
              marginRight: "0px",
            }}>
            <div className="col-12 leaveHeading text-left">
              <h3>SKILL ASSESSMENT APPLY</h3>
            </div>



            <div className="col">
              <button
                className="btn BackImga"
                onClick={(e) => {
                  navigate("/assessments");
                }}
              >
                <img className="PreviousPages" src={BackImage} />
                <span></span>

              </button>
            </div>
          </div>
          <div className="OuterEmployee-Details" style={{ padding: "23px 15px" }}>
            <div className="EmployeeDetails row">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <div
                      className="row "
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <div
                        className="col-sm-3 col-md-3 col-lg-1 d-flex justify-content-start ProfileImages"
                        style={{ minWidth: "117px", maxWidth: "114px" }}
                      >
                        <img src={state.SideBarFiles.UDSEmployeeeImage != null ?
                          state.SideBarFiles.UDSEmployeeeImage : Profile} width={"90px"} height={"90px"}

                        />
                      </div>
                      <div className="col-md-9 col-sm-12 col-lg-9 text-left">

                        <h3 className="m-0 mt-2">
                          {state.skillassessmentretieveempdatas.skillassessmentsempDatas?.user_id?.first_name}&nbsp;

                        </h3>
                        <p style={{ fontWeight: 600, fontSize: "14px", marginLeft: "2px" }}>
                          {state.skillassessmentretieveempdatas.skillassessmentsempDatas?.user_id?.user_role?.role}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* -----------Man---Power---performs=-------------------- */}
          <div
            className="row EmpPorfile ManPowerPerfomanceCards"
            style={{ padding: "48px 16px", gap: "70px" }}
          >
            {state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
              state.skillassessmentretieveempdatas.skillassessmentsempDatas
                .perform_types != undefined &&
              state.skillassessmentretieveempdatas.skillassessmentsempDatas
                .perform_types != null &&
              state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types
                .perform_id != undefined &&
              state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types
                .perform_id != null &&
              state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types.perform_id.map(
                (item, index) => {
                  const transformedGradingName = item.grading_name
                    .toLowerCase()
                    .replace(/\s+/g, "_")
                    .replace(/[^a-z0-9_]/g, "_");
                  return (
                    <div
                      className="col-md-3  nav nav-tabs "
                      id="ex3-tab-1"
                      key={index}
                       style={{cursor:state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
                        state.skillassessmentretieveempdatas.skillassessmentsempDatas != null &&
                        state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
                        undefined &&
                        state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer != null&&
                        state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer.is_completed != null &&
                        state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer.is_completed != undefined &&
                        state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer.is_completed == true ? "not-allowed":"pointer"}}
                    >
                      <div className="card" style={{ height: "125px" }}>
                        <div
                          style={{ padding: "6px 16px " }}
                          className={`  card-body   ${state.ManPowerActiveDataTabs.ActiveTabManPower ==
                            index
                            ? "active"
                            : ""
                            }`}
                          onClick={(e) => {
                            if(state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
                              state.skillassessmentretieveempdatas.skillassessmentsempDatas != null &&
                              state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
                              undefined &&
                              state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer != null&&
                              state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer.is_completed != null &&
                              state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer.is_completed != undefined &&
                              state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer.is_completed == true
                             ){ 
                              e.preventDefault()
                              }
                              else {
                                HandleManPowerfunction(item, index);

                              }

                          }}
                        >
                          <div className="WIthPendingStatus">
                            <h5 style={{ width: "80%" }}>{item.grading_name}</h5>

                            <div className="ICONS">
                              {state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
                                state.skillassessmentretieveempdatas.skillassessmentsempDatas != null &&
                                state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
                                undefined &&
                                state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer != null &&
                                Object.keys(
                                  state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer
                                ).map((innerKey, index) => {
                                  const value =
                                    state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer[
                                    innerKey
                                    ];


                                  return (
                                    <React.Fragment key={index}>
                                      {typeof value === "object" &&
                                        item.grading_name
                                          .toLowerCase()
                                          .replace(/\s+/g, "_")
                                          .replace(/[^a-z0-9_]/g, "_") ===
                                        innerKey ? (
                                        <img
                                          src={
                                            item.grading_name
                                              .toLowerCase()
                                              .replace(/\s+/g, "_")
                                              .replace(/[^a-z0-9_]/g, "_") ===
                                              innerKey && value != null
                                              ? correctIcons
                                              : Pending
                                          }
                                        />
                                      ) : null}
                                    </React.Fragment>
                                  );
                                })}

                              <img src={ArrowIcons} />
                            </div>
                          </div>
                          <p style={{ padding: "30px", width: "100%" }}>
                            <span style={{ color: "black" }}>Total Points :</span>{" "}
                            {item.total_points}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                }
              )}
          </div>

        </div>





      </div>

    </>)
}

export default Empskillassessments